import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_insert_into_print_queueService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { printerId?: number, title?: string, contentType?: string, content?: string, source?: string, batchNumber?: number, printSequence?: number, transactionId?: string, reference?: string }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

